import React from 'react';
import { IonItem, IonLabel, IonInput } from '@ionic/react';
import { visuallyHiddenInputStyle } from './constants';

interface TitleBlockProps {
  topicTitle: string;
  setTopicTitle: (value: string) => void;
  /** What the field is called, e.g. "Headline" for news. */
  label?: string;
  placeholder?: string;
}

/**
 * Editable topic-title field — the title-only block for the component-driven
 * per-type edit forms, and the first body of `TopicBasicsBlock`'s card. Topic
 * type is fixed at creation (chosen in the create type-picker, immutable
 * thereafter), so there is no type-selection UI here; the legacy
 * `TitleAndTypeBlock` keeps the chips for the legacy `TopicView` path.
 *
 * The visually-hidden native mirror input carries the canonical `topic-title-input`
 * testid E2E types into (the Ionic `IonInput` does not reliably expose one).
 */
const TitleBlock: React.FC<TitleBlockProps> = ({
  topicTitle,
  setTopicTitle,
  label = 'Topic Title',
  placeholder = 'Enter topic title',
}) => (
  <>
    <IonItem lines="inset">
      <IonLabel position="stacked" className="topic-form-label">
        {label} *
      </IonLabel>
      <IonInput
        value={topicTitle}
        onIonInput={e => setTopicTitle((e.detail.value as string) || '')}
        placeholder={placeholder}
        maxlength={64}
      />
    </IonItem>
    <input
      type="text"
      data-testid="topic-title-input"
      value={topicTitle}
      onInput={e => setTopicTitle((e.target as HTMLInputElement).value || '')}
      onChange={e => setTopicTitle(e.target.value)}
      style={visuallyHiddenInputStyle}
      aria-hidden="true"
      tabIndex={-1}
    />
  </>
);

export default TitleBlock;
